import { Configuration, LogLevel } from '@azure/msal-browser';

// MSAL configuration for multi-tenant Azure AD authentication
export const msalConfig: Configuration = {
  auth: {
    // Azure AD app registration client ID
    clientId: '23ba13e9-b4a6-4aa1-8d79-2f3ef7282e9c',
    
    // Multi-tenant endpoint - allows any Azure AD account
    authority: 'https://login.microsoftonline.com/common',
    
    // Redirect URI - must match Azure app registration
    redirectUri: process.env.NODE_ENV === 'production' 
      ? 'https://engineer.mach0.net'
      : window.location.origin,
    postLogoutRedirectUri: process.env.NODE_ENV === 'production'
      ? 'https://engineer.mach0.net' 
      : window.location.origin,
    
    // Navigate to original page after login
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // Use localStorage for SSO across tabs
    cacheLocation: 'localStorage',
    
    // Enable for IE11/Edge legacy support
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      logLevel: LogLevel.Warning,
    },
    // Support for PWA
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
  },
};

// Minimal scopes - just enough for user identity
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
  prompt: 'select_account' as const,  // Show account picker if multiple accounts
  extraQueryParameters: {
    domain_hint: 'organizations',  // Skip personal Microsoft accounts
  },
};

// Silent request configuration
export const silentRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
  prompt: 'none' as const,
};

// Token request for API calls
export const tokenRequest = {
  scopes: ['openid', 'profile', 'email'],
  forceRefresh: false,
};